import {batch, useDispatch, useSelector} from "react-redux";
import {useState} from "react";
import {optionAction} from "../../redux/store";
import {COLORWAY_CODES} from "../../../core/constants/color";
import {getColorWayDetail} from "../../../core/api/optionApis";

const colorwayCache = new Map();

export const useColorway = () => {
  const dispatch = useDispatch();
  // const [expandedColorway, setExpandedColorway] = useState(null);

  const currentProduct = useSelector(state => state.optionWindow.currentVehicle);
  const configData = useSelector(state => state.optionWindow.CONFIG_DATA);



  const handleColorwayChange = async (colorwayCode) => {
    const intKeyColor = configData["INT_KEY"];
    const intSecondaryColor = configData["INT_SECONDARY"];
    const intThirdColor = configData["INT_THIRD"];
    const cacheKey = `${currentProduct.id}_${colorwayCode}`;

    const applyColorSettings = (colorwayValue, colorGroup = null) => {
      batch(() => {
        dispatch(optionAction.setSendData({
          key: "COLORWAY",
          value: colorwayValue
        }));

        if (colorGroup) {
          dispatch(optionAction.setInteriorDetailPart(colorGroup));
        }

        if (intKeyColor) {
          dispatch(optionAction.setSendData({
            key: "INT_KEY",
            value: intKeyColor
          }));
        }

        if (intSecondaryColor && colorwayCode !== COLORWAY_CODES.SINGLE) {
          dispatch(optionAction.setSendData({
            key: "INT_SECONDARY",
            value: intSecondaryColor
          }));
        }

        if (intThirdColor && colorwayCode === COLORWAY_CODES.REAR_HIGHLIGHT) {
          dispatch(optionAction.setSendData({
            key: "INT_THIRD",
            value: intThirdColor
          }));
        }
      });
    };

    if (colorwayCache.has(cacheKey)) {
      const cachedData = colorwayCache.get(cacheKey);
      const colorGroup = {
        "INT_KEY": [],
        "INT_SECONDARY": [],
        "INT_THIRD": []
      };

      for (let group of cachedData.colorwayGroups) {
        for (let colorTarget of group.colorwayItems) {
          colorGroup[group.groupName].push("INT_" + colorTarget);
        }
      }

      applyColorSettings(colorwayCode, colorGroup);
      return;
    }

    try {
      const res = await getColorWayDetail(currentProduct.id, colorwayCode);

      if (res.data.result && res.data.message === "SUCCESS") {
        const data = res.data.data;
        colorwayCache.set(cacheKey, data);
        const colorGroup = {
          "INT_KEY": [],
          "INT_SECONDARY": [],
          "INT_THIRD": []
        };

        for (let group of data.colorwayGroups) {
          for (let colorTarget of group.colorwayItems) {
            colorGroup[group.groupName].push("INT_" + colorTarget);
          }
        }

        applyColorSettings(colorwayCode, colorGroup);
      }
      // else {
      //   const fallbackValue = colorwayCode === COLORWAY_CODES.SINGLE
      //     ? COLORWAY_CODES.SINGLE
      //     : COLORWAY_CODES.DUAL;
      //   applyColorSettings(fallbackValue);
      // }
    } catch (error) {
      console.error("Colorway change failed:", error);
    }
  };

  const handleColorwayToggle = (colorwayCode) => {
    // const newExpandedColorway = expandedColorway === colorwayCode ? null : colorwayCode;
    const newExpandedColorway = configData?.COLORWAY === colorwayCode ? configData?.COLORWAY : colorwayCode;
    // setExpandedColorway(newExpandedColorway);

    if (newExpandedColorway) {
      handleColorwayChange(newExpandedColorway);
    }
  };

  return {
    // expandedColorway,
    handleColorwayToggle
  };
};
